import type { ColDef } from 'ag-grid-community'
import type { ColumnVisibilityOption } from 'src/hooks/useColumnVisibility'

/** A column's id as AG Grid sees it: `colId` when set, else its `field`. */
const columnId = <TRow>(column: ColDef<TRow>): string =>
  String(column.colId ?? column.field ?? '')

/** The chooser's options for a grid: every column that has an id and a header. */
export const toColumnOptions = <TRow>(
  columnDefs: ColDef<TRow>[]
): ColumnVisibilityOption[] =>
  columnDefs
    .filter((column) => columnId(column) && column.headerName)
    .map((column) => ({
      colId: columnId(column),
      headerName: column.headerName ?? '',
    }))

/** The grid's columns with the chooser's hidden ones switched off. */
export const applyColumnVisibility = <TRow>(
  columnDefs: ColDef<TRow>[],
  isHidden: (colId: string) => boolean
): ColDef<TRow>[] =>
  columnDefs.map((column) => ({
    ...column,
    hide: isHidden(columnId(column)),
  }))
